import { put, call, select, takeLatest } from "redux-saga/effects";
import * as R from "ramda";
import { DETAIL } from "../actions";
import generateAction from "../../utils/action-helpers";
import redirectToLogin from "../../utils/redirect-to-login";
import { fetchProposal } from "../../api/proposal";
import { getItemsByCustomerId } from "../../api/item";

function* getProposalsSaga(action) {
  const { kukey, record } = action.payload;
  try {
    const results = yield call(fetchProposal, kukey, record);
    const proposal = [];
    if (results.data) {
      results.data.forEach((element, index) => {
        if (element.rule !== "NO_CLIENT" && index < 2) proposal.push(element);
      });
    }
    // add manual proposal
    proposal.push({
      id: -1,
      user: "MANUAL",
      priority: false,
      origins: [],
      rules: [],
      items: []
    });
    yield put(generateAction(DETAIL.GET_PROPOSALS_SUCCESS, proposal));

    if (!R.isEmpty(proposal)) {
      const { tercero } = proposal[0];
      if (tercero) {
        yield put(generateAction(DETAIL.GET_ITEMS, { tercero }));
      }
    }
  } catch (err) {
    if (err && err.response && err.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(DETAIL.GET_PROPOSALS_ERROR));
  }
}
const findPendingIndex = (kukey, record) =>
  R.findIndex(element => element.kukey === kukey && element.record === record);

function* getItemsSaga(action) {
  const { tercero } = action.payload;
  try {
    const results = yield call(getItemsByCustomerId, tercero);
    const clientItems = results && results.data ? results.data : [];
    const { proposals, selectedProposal } = yield select(state => state.detail);
    const activeProposal = proposals[selectedProposal];
    activeProposal.items.map(item => {
      const itemIndex = R.findIndex(element => {
        const { society, customer, year, period, document, position, expiration } = item;
        return (
          // Just in case they are not the same type
          // eslint-disable-next-line eqeqeq
          position == element.QT_POSITION &&
          // eslint-disable-next-line eqeqeq
          year == element.ID_PERIOD &&
          // eslint-disable-next-line eqeqeq
          period == element.CO_PERIOD_VARIANT &&
          // eslint-disable-next-line eqeqeq
          society == element.CO_SOCIETY &&
          // eslint-disable-next-line eqeqeq
          customer == element.ID_CUSTOMER &&
          // eslint-disable-next-line eqeqeq
          document == element.CO_DOCUMENT_NUMBER &&
          // eslint-disable-next-line eqeqeq
          expiration == element.QT_EXPIRATION_POSITION
        );
      })(clientItems);
      if (itemIndex !== -1) {
        clientItems[itemIndex] = {
          ...clientItems[itemIndex],
          tercero,
          selected: !clientItems[itemIndex].selected
        };
      }
      return item;
    });
    yield put(generateAction(DETAIL.GET_ITEMS_SUCCESS, clientItems));
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      redirectToLogin();
    }
    yield put(generateAction(DETAIL.GET_ITEMS_ERROR, error));
  }
}

function* searchTransfer(action) {
  const { kukey, record } = action.payload;
  try {
    const pending = yield select(state => state.pending.pending);
    let index = findPendingIndex(kukey, record)(pending);
    if (index === -1) {
      const prevalidated = yield select(state => state.automatic.prevalidated);
      index = findPendingIndex(kukey, record)(prevalidated);
      if (index === -1) {
        yield put(generateAction(DETAIL.SEARCH_TRANSFER_ERROR));
      } else {
        yield put(generateAction(DETAIL.SEARCH_TRANSFER_SUCCESS, prevalidated[index]));
      }
    } else {
      yield put(generateAction(DETAIL.SEARCH_TRANSFER_SUCCESS, pending[index]));
    }
  } catch (err) {
    yield put(generateAction(DETAIL.SEARCH_TRANSFER_ERROR), err);
  }
}
export default function* detailSagas() {
  yield takeLatest(DETAIL.GET_PROPOSALS, getProposalsSaga);
  yield takeLatest(DETAIL.GET_ITEMS, getItemsSaga);
  yield takeLatest(DETAIL.SEARCH_TRANSFER, searchTransfer);
}
